/**
 * @desc 根据单位类型编号查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.BaseUnitTypeDetailsResponseDto>;
export function request(unitTypeCode: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseUnitType/bySecondWordAndCode/${unitTypeCode}`, {
      method: "GET",

      ...options,
    }),
  );
}
